export const GET_RESTRICTIONS = "GET_RESTRICTIONS";
export const RESTRICTIONS_RECEIVED = "RESTRICTIONS_RECEIVED";
export const GET_SUB_RESTRICTIONS = "GET_SUB_RESTRICTIONS";
export const SUB_RESTRICTIONS_RECEIVED = "SUB_RESTRICTIONS_RECEIVED";
export const SUB_ACTIVITY_DATA_RECEIVED = "SUB_ACTIVITY_DATA_RECEIVED";
export const SET_GLOBAL_FILTERS = "SET_GLOBAL_FILTERS";
export const PUT_SUB_ACTIVITY_DATA = "PUT_SUB_ACTIVITY_DATA";
export const PUT_OCCUPANCY_DATA = "PUT_OCCUPANCY_DATA";
export const TOGGLE_RESET_BUTTON = "TOGGLE_RESET_BUTTON";
export const SET_GLOBAL_FILTERS_FOR_PFCV = "SET_GLOBAL_FILTERS_FOR_PFCV";
export const GET_TIME_LIMIT_VALUES = "GET_TIME_LIMIT_VALUES";
export const TIME_LIMIT_VALUES_RECEIVED = "TIME_LIMIT_VALUES_RECEIVED";
export const SET_TIME_LIMIT_FILTER = "SET_TIME_LIMIT_FILTER";
export const GET_PERMIT_PARKING_VALUES = "GET_PERMIT_PARKING_VALUES";
export const GET_PERMIT_DATA_VALUES = "GET_PERMIT_DATA_VALUES";
export const GET_PRICE_DATA_VALUES = "GET_PRICE_DATA_VALUES";
export const STORE_PRICE_DATA = "STORE_PRICE_DATA";
export const PERMIT_PARKING_VALUES_RECEIVED = "PERMIT_PARKING_VALUES_RECEIVED";
export const STORE_USER_CLASS_CATEGORY_VALUES = "STORE_USER_CLASS_CATEGORY_VALUES";
export const SELECTED_PERMIT_VALUES = "SELECTED_PERMIT_VALUES";
export const STORE_PERMIT_LINKS_AND_SUBRESTRICTION_IDS =
    "STORE_PERMIT_LINKS_AND_SUBRESTRICTION_IDS";
export const STORE_PRICE_LINKS_AND_SUBRESTRICTION_IDS = "STORE_PRICE_LINKS_AND_SUBRESTRICTION_IDS";
export const STORE_PERMITS_DATA = "STORE_PERMITS_DATA";
export const SELECTED_PRICE_VALUES = "SELECTED_PRICE_VALUES";
export interface FilterState {
    isRestrictionsFetched: boolean;
    restrictions: RestrictionReceivedInterface;
    isSubRestrictionsFetched: boolean;
    subRestrictions: SubRestrictionReceivedInterface;
    isSubActivityDataFetched: boolean;
    subActivityData: SubRestrictionReceivedInterface;
    resetButton: boolean;
    globalFilters: GlobalFiltersInterface;
    globalFiltersForPFCV: Set<string>;
    allGlobalFilters: string[];
    timeLimitValues: TimeLimitValuesInterface;
    selectedTimeLimit: (string | number)[] | null;
    isSelectedTimeLimitReceived: boolean;
    permitParkingValues: PermitParkingValuesInterface;
    selectedPermitValues: ValueType[] | null;
    permitLinksAndSubRestrictionIds: SelectedPermitPayload;
    userClassCategoryValues: string[];
    permitsData: PermitData;
    priceLimitValues: PriceData;
    priceLinksAndSubRestrictionIds: SelectedPermitPayload;
    selectedPriceValues: ValueType[] | null;
    permitsAvailable: boolean;
}

export const defaultRestrictionState = {
    meta: {
        count: 0,
        next: null,
        previous: null
    },
    results: []
};

export interface ValueType {
    label: string;
    value: number;
}
export interface SelectedPermitPayload {
    [key: string]: number[];
}
export interface GetRestrictionsInterface {
    fields: string;
}

export interface RestrictionsReceivedInterface {
    meta: {
        count: number;
        next: string | null;
        previous: string | null;
    };
}

export interface GetSubRestrictionsInterface {
    fields: string;
    in_manager?: boolean;
    name?: boolean;
}

export interface RestrictionReceivedInterface {
    meta: {
        count: number;
        next: string | null;
        previous: string | null;
    };
    results: {
        id: number;
        name: string;
    }[];
}

export interface SubRestrictionReceivedInterface {
    meta: {
        count: number;
        next: string | null;
        previous: string | null;
    };
    results: SubRestrictionRecord[];
}

export interface SubRestrictionRecord {
    activity: {
        id: number;
        name: string;
    };
    color: string;
    curbside_function: {
        modified: string;
        created: string;
        id: number;
        name: string;
    };
    curbside_users?: number;
    dash_style: string;
    display_name: string;
    editable_max_stay?: boolean;
    editable_parking_price?: boolean;
    editable_parking_spaces?: boolean;
    filter_section: string;
    id: number;
    in_manager: boolean;
    in_viewer: boolean;
    name: string;
    dashboard_color: string;
    priority: any;
    hotspot_url: {
        [name: string]: string;
    };
    occupancy_percent: number;
    permit_type?: string;
}

export type UniqueSubRestrictionRecord = Omit<SubRestrictionRecord, "id"> & { id: number[] };
export interface PermitData {
    [permitName: string]: {
        displayname_ids: number[];
        link_ids: number[];
        sub_activity_ids: number[];
    };
}

export interface PriceData {
    [price: string]: {
        displayname_ids: number[];
        link_ids: number[];
        sub_activity_ids: number[];
    };
}

export interface GlobalFiltersInterface {
    date: string;
    sub_activity: string;
    time: string;
    userClassName?: number;
}

export interface PutSubActivityInterface {
    selectedCurbsideFunction: number;
    selectedRestiction: number;
    selectedUser: number;
    selectedUserNumber: number;
    selectedOccupancyPercent: number;
}

export interface TimeLimitValuesInterface {
    time_limit: number[];
}

export interface PermitParkingValue {
    permit_type: string;
    id: number;
    name: string;
    created?: string;
    modified?: string;
    description?: string;
    color: string;
}

export interface PermitParkingValuesInterface {
    meta: {
        count: number;
        next: string | null;
        previous: string | null;
    };
    results: PermitParkingValue[];
}

export interface GetRestrictions {
    type: typeof GET_RESTRICTIONS;
    payload: { params: GetRestrictionsInterface };
}

export interface RestrictionReceived {
    type: typeof RESTRICTIONS_RECEIVED;
    payload: { data: RestrictionReceivedInterface };
}

export interface GetSubRestrictions {
    type: typeof GET_SUB_RESTRICTIONS;
    payload: { params: GetSubRestrictionsInterface };
}

export interface SubRestrictionReceived {
    type: typeof SUB_RESTRICTIONS_RECEIVED;
    payload: { data: SubRestrictionReceivedInterface };
}

export interface SubActivityDataReceived {
    type: typeof SUB_ACTIVITY_DATA_RECEIVED;
    payload: { data: SubRestrictionReceivedInterface };
}

export interface SetGlobalFilters {
    type: typeof SET_GLOBAL_FILTERS;
    payload: { data: [GlobalFiltersInterface, string[]] };
}

export interface SetGlobalFiltersForPFCV {
    type: typeof SET_GLOBAL_FILTERS_FOR_PFCV;
    payload: { data: Set<string> };
}

export interface PutSubActivityData {
    type: typeof PUT_SUB_ACTIVITY_DATA;
    payload: { data: PutSubActivityInterface; afterProcess: () => void };
}

export interface PutOccupancyData {
    type: typeof PUT_OCCUPANCY_DATA;
    payload: { data: number; afterProcess: () => void };
}

export interface ToggleResetButton {
    type: typeof TOGGLE_RESET_BUTTON;
    payload: { data: boolean };
}

export interface GetTimeLimitValues {
    type: typeof GET_TIME_LIMIT_VALUES;
}

export interface TimeLimitValuesReceived {
    type: typeof TIME_LIMIT_VALUES_RECEIVED;
    payload: { data: TimeLimitValuesInterface };
}

export interface SetTimeLimitFilter {
    type: typeof SET_TIME_LIMIT_FILTER;
    payload: { data: null | (string | number)[]; isSelectedTimeLimitReceived: boolean };
}

export interface GetPermitParkingValues {
    type: typeof GET_PERMIT_PARKING_VALUES;
    payload: { params: GetRestrictionsInterface };
}
export interface GetPermitDataPayload {
    date: string;
    time: string;
}

export interface GetPriceDataPayload {
    date: string;
    time: string;
}
export interface GetPermitDataValues {
    type: typeof GET_PERMIT_DATA_VALUES;
    payload: GetPermitDataPayload;
}
export interface GetPriceDataValues {
    type: typeof GET_PRICE_DATA_VALUES;
    payload: GetPriceDataPayload;
}

export interface PermitParkingValuesReceived {
    type: typeof PERMIT_PARKING_VALUES_RECEIVED;
    payload: { data: PermitParkingValuesInterface };
}

export interface StoreUserClassCategoryValues {
    type: typeof STORE_USER_CLASS_CATEGORY_VALUES;
    payload: { data: string[] };
}

export interface SelectedPermitParkingValues {
    type: typeof SELECTED_PERMIT_VALUES;
    payload: { data: ValueType[] | null };
}
export interface StorePermitLinksAndSubRestrictionIds {
    type: typeof STORE_PERMIT_LINKS_AND_SUBRESTRICTION_IDS;
    payload: { data: SelectedPermitPayload };
}

export interface StorePermitsData {
    type: typeof STORE_PERMITS_DATA;
    payload: { data: PermitData };
}

export interface StorePricedata {
    type: typeof STORE_PRICE_DATA;
    payload: { data: PriceData };
}
export interface StorePricetLinksAndSubRestrictionIds {
    type: typeof STORE_PRICE_LINKS_AND_SUBRESTRICTION_IDS;
    payload: { data: SelectedPermitPayload };
}
export interface SelectedPriceValues {
    type: typeof SELECTED_PERMIT_VALUES;
    payload: { data: ValueType[] | null };
}
export type FilterTypes =
    | GetRestrictions
    | RestrictionReceived
    | GetSubRestrictions
    | SubRestrictionReceived
    | SubActivityDataReceived
    | SetGlobalFilters
    | SetGlobalFiltersForPFCV
    | PutSubActivityData
    | ToggleResetButton
    | GetTimeLimitValues
    | TimeLimitValuesReceived
    | SetTimeLimitFilter;
